import { AdminCarrierTable } from '../views/index';
import { TruckLaneCarrierMatch } from '../../lanes';

export const ADMIN_LANES_CARRIERS_TABLE = (
	carrierList: Array<TruckLaneCarrierMatch> = []
): Array<AdminCarrierTable> => {
	let results: Array<AdminCarrierTable> = [];
	if (carrierList.length > 0) {
		carrierList.map((truckLaneCarrierMatch) => {
			let row = {} as AdminCarrierTable;
			const carrier = truckLaneCarrierMatch.carrier;
			row.business_name = carrier.businessName;
			row.carrierId = carrier.id;
			row.oldCarrierId = carrier.oldCarrierId;
			row.dot = carrier.dot;
			row.email = carrier.emailAddress;
			row.mc = carrier.mc;
			row.reviewed = !truckLaneCarrierMatch.toBeReviewed;
			results.push(row);
		});
	}
	return results;
};
